const listeners = new Set();
let pending = [];
let nextId = 0;
const confirmations = new Map();
export function notify(message, { tone = 'info' } = {}) {
 pending = [...pending, { id: ++nextId, message: String(message ?? ''), tone }];
 listeners.forEach(listener => listener());
}
export function confirmAction(message, { title = 'Are you sure?', confirmLabel = 'Confirm', cancelLabel = 'Cancel' } = {}) {
 const id = ++nextId;
 return new Promise(resolve => {
  confirmations.set(id, resolve);
  pending = [...pending, { id, message: String(message ?? ''), tone: 'warning', kind: 'confirm', title, confirmLabel, cancelLabel }];
  listeners.forEach(listener => listener());
 });
}
export function resolveConfirmation(id, accepted = false) {
 const resolve = confirmations.get(id);
 confirmations.delete(id);
 pending = pending.filter(alert => alert.id !== id);
 resolve?.(accepted === true);
 listeners.forEach(listener => listener());
}
export function subscribeAlerts(listener) { listeners.add(listener); return () => listeners.delete(listener); }
export function getAlerts() { return pending; }
export function dismissAlert(id) { resolveConfirmation(id, false); }

